'use client';

import useJWT from '@/hooks/useJWT';
import { JWT_LOCALSTORAGE_KEY } from '@/lib/consts';
import { deploymentEnvironment } from '@/lib/environment';
import { type ReactNode, useEffect } from 'react';
interface Props {
  children: ReactNode;
}
export default function ResetChatWidgetEventListener({
  children
}: Props) {
  const {
    register
  } = useJWT();
  useEffect(() => {
    if (deploymentEnvironment !== 'development') return;
    const resetChat = () => {
      localStorage.removeItem(JWT_LOCALSTORAGE_KEY);
      register();
      location.reload();
    };
    const messageListener = (event: MessageEvent) => {
      if (event.origin !== 'https://localhost:3000') return;
      if (event.data?.type !== 'reset-chat-widget') return;
      resetChat();
    };
    window.addEventListener('message', messageListener);
    return () => {
      window.removeEventListener('message', messageListener);
    };
  }, [register]);
  return <>{children}</>;
}